import { RoutingStep } from '../../../../../../../../../../../../models/Routes';
import ListingInformationPage from './pages/ListingInformationPage';

export default [
  {
    index: true,
    element: ListingInformationPage,
    labelId: 'listingInformation',
    stepName: 'listingInformation',
  },
] as Array<RoutingStep>;
